import React from "react";
import {useHistory} from "react-router-dom";
import {Fab} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function Close({ fileId }) {
  const history = useHistory();

  return (
    <div style={{margin:"1rem", position:'absolute', top:0, right:0}}>
      <Fab style={{zIndex:1}}
        onClick={() => {
          history.goBack();
        }}
      >
        <CloseIcon />
      </Fab>
    </div>
  );
}
